import type { SVGComponentProps } from 'BreetHelpers';

export const QrIcon = ({ ...rest }: SVGComponentProps) => (
	<svg
		width='20'
		height='20'
		viewBox='0 0 20 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<path
			d='M1.66663 7.49935V5.41602C1.66663 3.34102 3.34163 1.66602 5.41663 1.66602H7.49996'
			stroke='#022745'
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<path
			d='M12.5 1.66602H14.5833C16.6583 1.66602 18.3333 3.34102 18.3333 5.41602V7.49935'
			stroke='#022745'
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<path
			d='M18.3334 13.334V14.584C18.3334 16.659 16.6584 18.334 14.5834 18.334H13.3334'
			stroke='#022745'
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<path
			d='M7.49996 18.3333H5.41663C3.34163 18.3333 1.66663 16.6583 1.66663 14.5833V12.5'
			stroke='#022745'
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<path
			d='M8.75004 5.83398V7.50065C8.75004 8.33398 8.33337 8.75065 7.50004 8.75065H5.83337C5.00004 8.75065 4.58337 8.33398 4.58337 7.50065V5.83398C4.58337 5.00065 5.00004 4.58398 5.83337 4.58398H7.50004C8.33337 4.58398 8.75004 5.00065 8.75004 5.83398Z'
			stroke='#022745'
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<path
			d='M15.4167 5.83398V7.50065C15.4167 8.33398 15 8.75065 14.1667 8.75065H12.5C11.6667 8.75065 11.25 8.33398 11.25 7.50065V5.83398C11.25 5.00065 11.6667 4.58398 12.5 4.58398H14.1667C15 4.58398 15.4167 5.00065 15.4167 5.83398Z'
			stroke='#022745'
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<path
			d='M8.75004 12.5V14.1667C8.75004 15 8.33337 15.4167 7.50004 15.4167H5.83337C5.00004 15.4167 4.58337 15 4.58337 14.1667V12.5C4.58337 11.6667 5.00004 11.25 5.83337 11.25H7.50004C8.33337 11.25 8.75004 11.6667 8.75004 12.5Z'
			stroke='#022745'
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<path
			d='M15.4167 12.5V14.1667C15.4167 15 15 15.4167 14.1667 15.4167H12.5C11.6667 15.4167 11.25 15 11.25 14.1667V12.5C11.25 11.6667 11.6667 11.25 12.5 11.25H14.1667C15 11.25 15.4167 11.6667 15.4167 12.5Z'
			stroke='#022745'
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);
